import {timestampGameEndedState, timestampGameStartedState} from '@/domains/Store/atoms'
import clsx from 'clsx'
import {useAtomValue} from 'jotai'
import {useCallback, useEffect, useRef, useState} from 'react'
import {getStopwatchTime} from './Stopwatch.utils'

export const Stopwatch = () => {
  const intervalTimer = useRef<NodeJS.Timeout | null>()
  const gameStartedTimestamp = useAtomValue(timestampGameStartedState)
  const gameEndedTimestamp = useAtomValue(timestampGameEndedState)
  const [stopwatchTime, setStopwatchTime] = useState<string | null>(null)

  const updateStopwatch = useCallback(() => {
    if (!gameStartedTimestamp) {
      return
    }

    // get time from game start to now or game end
    const time = getStopwatchTime(gameStartedTimestamp, gameEndedTimestamp || Date.now())
    if (time) {
      setStopwatchTime(time)
    }
  }, [gameStartedTimestamp, gameEndedTimestamp])

  useEffect(() => {
    if (gameStartedTimestamp && !stopwatchTime) {
      intervalTimer.current = setInterval(updateStopwatch, 60)
    }

    if (gameEndedTimestamp) {
      clearInterval(intervalTimer.current!)
    }
  }, [gameStartedTimestamp, gameEndedTimestamp, stopwatchTime])

  return (
    <div className="absolute top-0 flex w-full justify-center">
      <div
        id="timer"
        className={clsx(
          'h-[48px]',
          'flex w-fit min-w-[125px] items-center justify-center rounded-[16px] bg-[rgba(1,50,102,0.8)] px-[30px] pt-[2px] text-center font-mono text-[24px] text-white',
          stopwatchTime ? 'visible' : 'hidden',
        )}
      >
        {stopwatchTime ? stopwatchTime : '0.00'}
        {/* <div className="flex flex-1 items-center ">
        </div> */}
      </div>
    </div>
  )
}
